import { estimatedColumnWidth } from "../helpers";
import { formatCurrency, formatDate } from "@/utils/helpers";

const textColumn = (label, columnId, widthKey = columnId) => ({
  label,
  value: true,
  columnId,
  width: estimatedColumnWidth(widthKey),
  resizable: true,
  formatter: (value) => String(value ?? "")
});

const dateColumn = (label, columnId) => ({
  ...textColumn(label, columnId, "date"),
  formatter: (value) => (value ? formatDate(new Date(value)) : "")
});

const amountColumn = (label, columnId) => ({
  ...textColumn(label, columnId, "amount"),
  formatter: (value) => (value ? formatCurrency(String(value)) : "")
});

// Same columns and labels as the Excel export (SupplierSheets.Outstanding).
export default function getSupplierOutstandingColumns() {
  return [
    textColumn("Supplier Number", "supplierNumber", "number"),
    textColumn("Supplier Name", "supplierName", "name"),
    textColumn("Type", "type"),
    textColumn("Number", "number"),
    textColumn("Invoice Num.", "supplierInvoiceNr", "number"),
    textColumn("Applied Against", "appliedInvoiceNumber", "number"),
    dateColumn("Invoice Date", "invoiceDate"),
    dateColumn("Transaction Date", "transactionDate"),
    dateColumn("Due Date", "dueDate"),
    textColumn("Days Overdue", "daysOverdue", "number"),
    textColumn("Status", "invoiceStatus", "status"),
    textColumn("Settlement", "settlementStatus", "status"),
    amountColumn("Total", "total"),
    amountColumn("Paid", "paidAmount"),
    textColumn("Payment No", "paymentNumbers", "number"),
    amountColumn("Advance Adjusted", "advanceAmount"),
    textColumn("Advance Payment No", "advanceNumbers", "number"),
    amountColumn("Credit Note", "creditNoteAmount"),
    textColumn("Credit Note No", "creditNoteNumbers", "number"),
    amountColumn("Balance", "balance")
  ];
}
